import React from 'react';
import type { ClaimStatus } from '../../types/researchDemo';
import { statusLabels } from '../../utils/researchDemo';
const styles: Record<ClaimStatus, string> = {
  approved: 'border-teal/30 bg-teal-pale text-navy',
  proposed: 'border-lavender/30 bg-lavender-pale text-lavender',
  'revision-requested': 'border-amber-300 bg-amber-50 text-amber-900',
  rejected: 'border-rose-200 bg-rose-50 text-rose-800'
};
export function StatusPill({
  status
}: {
  status: ClaimStatus;
}) {
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${styles[status]}`} data-id="element-2397" data-mp="1u3n4yi4fsjhp">
      {statusLabels[status]}
    </span>;
}